<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">システム管理者</div>
      </md-card-header>

      <md-card-content>
        <router-link
          :to="{name: 'BackendAdmins'}">
          <md-button class="md-raised">
            <md-icon>arrow_back</md-icon>
            <span>戻る</span>
          </md-button>
        </router-link>
      </md-card-content>

      <loading-spinner v-if="loadDetail"></loading-spinner>
      <md-card-content v-else-if="fetchDetail && errorNotFound()">
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <flash-message :errors="errorMessages"></flash-message>
          </div>
        </div>
      </md-card-content>
      <div class="md-layout" v-else-if="fetchDetail">
        <div class="md-layout-item md-size-20 md-small-size-100"></div>
        <div class="md-layout-item md-size-60 md-small-size-100">
          <flash-message :errors="errorMessages" v-if="errorMessages.length"></flash-message>
          <form @submit.prevent="onSubmit" novalidate>
            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>管理者名</label>
                </div>
                <div class="md-layout-item md-size-35 md-small-size-100">
                  <md-field :class="getValidationClass('name_last')">
                    <label>姓</label>
                    <md-input v-model="form.name_last" required autofocus
                              :disabled="sending"></md-input>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('name_last')">{{ getValidationResponseMessage('name_last') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.name_last.required">{{ errors.name_last.required }}</span>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-35 md-small-size-100">
                  <md-field :class="getValidationClass('name_first')"
                            :disabled="sending">
                    <label>名</label>
                    <md-input v-model="form.name_first" required
                              :disabled="sending"></md-input>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('name_first')">{{ getValidationResponseMessage('name_first') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.name_first.required">{{ errors.name_first.required }}</span>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>ログインID</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('username')">
                    <label>ログインID</label>
                    <md-input v-model="form.username" required :disabled="managerId !== null || sending"></md-input>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('username')">{{ getValidationResponseMessage('username') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.username.required">{{ errors.username.required }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.username.loginId">{{ errors.username.loginId }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.username.minLength">{{ errors.username.minLength }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.username.maxLength">{{ errors.username.maxLength }}</span>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>パスワード</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('password')">
                    <label>パスワード</label>
                    <md-input type="password" v-model="form.password" required
                              :disabled="sending"></md-input>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('password')">{{ getValidationResponseMessage('password') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.password.required">{{ errors.password.required }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.password.password">{{ errors.password.required }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.password.minLength">{{ errors.password.minLength }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.password.maxLength">{{ errors.password.maxLength }}</span>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100"></div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('passwordConfirm')">
                    <label>パスワードの確認</label>
                    <md-input type="password" v-model="form.passwordConfirm" required
                              :disabled="sending"></md-input>
                    <span class="md-error"
                          v-if="!$v.form.passwordConfirm.sameAs">{{ errors.passwordConfirm.sameAs }}</span>
                  </md-field>
                </div>
              </div>

              <md-snackbar :md-active.sync="showSnackBar"
                           :md-duration="snackbarDuration"
                           @md-closed="showSnackBar = false">
                <span>{{ successMessage }}</span>
                <md-button class="md-primary" @click="showSnackBar = false">閉じる</md-button>
              </md-snackbar>
            </md-card-content>

            <md-card-actions>
              <div class="md-layout md-alignment-center-center">
                <md-button class="md-primary md-raised" type="submit">
                  <md-icon>save</md-icon>
                  <span>登録する</span>
                </md-button>
              </div>
            </md-card-actions>
          </form>
        </div>
      </div>
    </md-card>
  </main>
</template>


<script>
  import FlashMessage                                         from '../../../components/FlashMessage';
  import Common                                               from '../../../modules/common';
  import CommonMixin                                          from "../../../mixins/commonMixin";
  import {apiClientWithManagerToken as apiClient, apiList}    from '../../../modules/apiClient';
  import {validationMixin}                                    from 'vuelidate'
  import {required, requiredIf, sameAs, minLength, maxLength} from 'vuelidate/lib/validators'
  import Validation                                           from "../../../modules/validation";
  import LoadingSpinner                                       from "../../../components/LoadingSpinner";

  export default {
    name      : "AdminNew",
    mixins    : [CommonMixin, validationMixin],
    props     : {
      id: String,
    },
    components: {
      LoadingSpinner,
      FlashMessage,
    },
    data      : () => ({
      loadDetail: false,
      managerId : null,
      form      : {
        name_last      : '',
        name_first     : '',
        username       : '',
        password       : '',
        passwordConfirm: '',
      },
      errors    : {
        name_last      : {
          required: Validation.errorMessage(Validation.rules.required, 'adminLastName'),
        },
        name_first     : {
          required: Validation.errorMessage(Validation.rules.required, 'adminFirstName'),
        },
        username       : {
          required : Validation.errorMessage(Validation.rules.required, 'username'),
          minLength: Validation.errorMessage(Validation.rules.minLength, 'username', 8),
          maxLength: Validation.errorMessage(Validation.rules.maxLength, 'username', 32),
          loginId  : Validation.errorMessage(Validation.rules.loginId, 'username'),
        },
        password       : {
          required : Validation.errorMessage(Validation.rules.required, 'password'),
          minLength: Validation.errorMessage(Validation.rules.minLength, 'password', 16),
          maxLength: Validation.errorMessage(Validation.rules.maxLength, 'password', 100),
          password : Validation.errorMessage(Validation.rules.password, 'password'),
        },
        passwordConfirm: {
          sameAs: Validation.errorMessage(Validation.rules.sameAs, 'password'),
        },
      },
    }),
    validations() {
      return {
        form: {
          name_last      : {
            required,
          },
          name_first     : {
            required,
          },
          username       : {
            required,
            minLength: minLength(8),
            maxLength: maxLength(32),
            loginId  : Validation.loginId,
          },
          password       : {
            required : requiredIf(function () {
              return !this.managerId;
            }),
            minLength: minLength(this.form.password ? 16 : 0),
            maxLength: maxLength(100),
            password : Validation.password,
          },
          passwordConfirm: {
            sameAs: sameAs('password'),
          },
        },
      };
    },
    mounted() {
      if (this.$props.id) {
        this.managerId = this.$props.id;
        this.getManagerDetail();
      } else {
        this.fetchDetail = true;
      }
    },
    methods   : {
      errorNotFound() {
        if (this.$props.id) {
          if (!this.managerId) {
            this.errorMessages = [Common.messages.manager.notFound];
            return true;
          }
        }
        return false;
      },
      initForm() {
        this.form = {
          name_last      : '',
          name_first     : '',
          username       : '',
          password       : '',
          passwordConfirm: '',
        };
      },
      createFormData() {
        return {
          name_last            : this.form.name_last,
          name_first           : this.form.name_first,
          username             : this.form.username,
          password             : this.form.password,
          password_confirmation: this.form.passwordConfirm,
        };
      },
      resetPassword() {
        this.form.password        = null;
        this.form.passwordConfirm = null;
      },
      parseManagerDetail(managerDetail) {
        this.managerId = managerDetail.id;
        this.form      = {
          name_last : managerDetail.name_last,
          name_first: managerDetail.name_first,
          username  : managerDetail.username,
          password  : managerDetail.password,
        };
      },
      getManagerDetail() {
        this.successMessage = null;
        this.sending        = true;
        this.loadDetail     = true;
        const detailUrl     = apiList.manager.detail.replace(':manager_id', this.managerId);
        this.managerId      = null;
        apiClient.get(detailUrl)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }

            this.parseManagerDetail(response.data.manager);
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending     = false;
            this.loadDetail  = false;
            this.fetchDetail = true;
          });
      },
      updateManagerAccount() {
        this.sending = true;
        const url    = apiList.manager.update.replace(':manager_id', this.managerId);
        apiClient.put(url, this.createFormData())
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            if (this.managerId) {
              this.resetPassword();
              this.showSnackBar   = true;
              this.successMessage = Common.messages.manager.updateSuccess;
            } else {
              this.errorMessages = [Common.messages.manager.updateError];
            }
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
            this.$v.$reset();
          });
      },
      registerManagerAccount() {
        this.sending          = true;
        this.validateResponse = [];
        apiClient.post(apiList.manager.register, this.createFormData())
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.setSnackBar(Common.messages.manager.registrySuccess);
            this.$router.replace({name: 'BackendAdmins'});
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
            this.$v.$reset();
          });
      },
      onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          if (this.$props.id) {
            this.updateManagerAccount();
          } else {
            this.registerManagerAccount();
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
